export const PitrSnapshotsMultipleDots = ({ fill }: { fill?: string }) => {
  const fillColor = fill || 'var(--mui-palette-text-gray1)';

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <circle cx='10' cy='12' r='5' stroke={fillColor} strokeWidth='2' />
      <mask id='path-3-inside-1_5928_3086' fill='white'>
        <path d='M15.4941 6.1875C18.085 6.85146 20 9.20207 20 12C20 14.7979 18.085 17.1485 15.4941 17.8125C17.0365 16.3542 18 14.2902 18 12C18 9.70982 17.0365 7.64584 15.4941 6.1875Z' />
      </mask>
      <path
        d='M15.4941 6.1875C18.085 6.85146 20 9.20207 20 12C20 14.7979 18.085 17.1485 15.4941 17.8125C17.0365 16.3542 18 14.2902 18 12C18 9.70982 17.0365 7.64584 15.4941 6.1875Z'
        fill={fillColor}
      />
      <path
        d='M15.4941 6.1875L15.7424 5.2188L11.9997 4.25969L14.8071 6.91412L15.4941 6.1875ZM20 12H21H20ZM15.4941 17.8125L14.8071 17.0859L11.9997 19.7403L15.7424 18.7812L15.4941 17.8125ZM18 12H19H18ZM15.4941 6.1875L15.2459 7.1562C17.4051 7.70954 19 9.66972 19 12H20H21C21 8.73442 18.7649 5.99338 15.7424 5.2188L15.4941 6.1875ZM20 12H19C19 14.3303 17.4051 16.2905 15.2459 16.8438L15.4941 17.8125L15.7424 18.7812C18.7649 18.0066 21 15.2656 21 12H20ZM15.4941 17.8125L16.1812 18.5391C17.9146 16.9002 19 14.5769 19 12H18H17C17 14.0034 16.1584 15.8082 14.8071 17.0859L15.4941 17.8125ZM18 12H19C19 9.42309 17.9146 7.09984 16.1812 5.46088L15.4941 6.1875L14.8071 6.91412C16.1584 8.19183 17 9.99655 17 12H18Z'
        fill={fillColor}
        mask='url(#path-3-inside-1_5928_3086)'
      />
    </svg>
  );
};
